export function useVacancySearchCard(vacancy: MaybeRef<Partial<Vacancy>>) {
  const { d } = useI18n()
  const { t } = useI18n({
    useScope: 'local',
  })

  // TODO: fixme, see VacancySearchCard.vue as well
  // Create a reactive reference to the vacancy
  const vacancyRef = ref(unref(vacancy))
  // Watch for changes to the vacancy prop
  watch(() => unref(vacancy), (newVal) => {
    vacancyRef.value = newVal
  }, { deep: true, immediate: true })

  const showOrganizationName = computed(() => {
    return !vacancyRef.value.isIndividualP2P && !!vacancyRef.value.organizationName
  })

  // Make tags reactive by using computed
  const tags = computed(() => {
    // Localize stored tags
    const localizedTags: string[] = (vacancyRef.value.tags || []).map(tag => t(`tag.${tag}`))

    // Add tags based on frequency and dates
    if (vacancyRef.value.frequency) {
      if (vacancyRef.value.frequency == Frequency.Once) {
        const { upcomingDates } = useVacancyDates(vacancyRef.value)
        localizedTags.push(upcomingDates.value.length > 1 ? t('tag.multipleDates') : t('tag.once'))
      }
      else {
        // TODO: fix enum type
        localizedTags.push(t(`tag.${vacancyRef.value.frequency}`))
      }
    }

    return localizedTags
  })

  // Transform tags to the format expected by the base component
  const formattedTags = computed(() => tags.value.map(tag => ({ text: tag })))

  const showDates = computed(() => vacancyRef.value.vacancyType == VacancyType.Activity)

  const { upcomingDates } = useVacancyDates(vacancyRef.value)

  const visibleDates = computed(() => {
    return upcomingDates.value.slice(0, 3)
  })

  const remainingDatesCount = computed(() => {
    return Math.max(0, upcomingDates.value.length - 3)
  })

  const remainingDatesLabel = computed(() => {
    return remainingDatesCount.value > 0 ? t('moreDates', { count: remainingDatesCount.value }) : ''
  })

  const imageUrl = computed(() => vacancyRef.value.headerImageUrl || vacancyRef.value.stockImageUrl)

  // Format dates for display
  const formattedDates = computed(() => {
    if (!showDates.value) return []
    return visibleDates.value.map(date => date ? d(new Date(date), 'short') : '')
  })

  return {
    showOrganizationName,
    formattedTags,
    formattedDates,
    remainingDatesLabel,
    imageUrl,
  }
}
